import * as React from "react"
import { useMemo } from "react"
import { AutocompleteAsyncDebounced } from "@components"
import { BACKEND_APIS } from "@constants"
import { selectedBrands } from "../@signals"


export default function SkuCandidatesBrandsFilter() {
    const filters = useMemo(() => {
        const f = {}
        if (selectedBrands.value?.length > 0) {
            f.selected = selectedBrands.value
        }
        return f
    }, [selectedBrands.value])

    return <AutocompleteAsyncDebounced
        multiple
        urlAjax={`${BACKEND_APIS.SKU_CANDIDATES}/brands`}
        label="Brands"
        placeholder="Search Brands..."
        value={selectedBrands.value}
        onChange={e => selectedBrands.value = e.target.value}
        queryParam="search"
        filters={filters}
    />
}
